import { KYMW0900Model } from "../kymw0900.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { GetGroupingListRequestModel } from '../vo/kymw0900-get-grouping-list-request.model';

/**
 * グルーピングコード一覧取得サービス
 *
 * @export GetGroupingListService
 * @class GetGroupingListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetGroupingListService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetGroupingListService
   */
  private successFunc: Function;

  model: KYMW0900Model;
  vo: GetGroupingListRequestModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGroupingListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        Grouping: {
          condition: {
            GroupingDiv142: this.vo.groupingDiv142,
            GroupingDiv163: this.vo.groupingDiv163,
            GroupingDiv185: this.vo.groupingDiv185,
            GroupingDiv240: this.vo.groupingDiv240,
            GroupingDiv210: this.vo.groupingDiv210,
            GroupingDiv302: this.vo.groupingDiv302,
            GroupingDiv515: this.vo.groupingDiv515,
            GroupingDiv451: this.vo.groupingDiv451,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetGroupingListService
   */
  execute(model: any, vo: GetGroupingListRequestModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW09getGroupingList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGroupingListService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.setGroupingList(data);
      if (this.successFunc) {
        this.successFunc(data);
      }
    }
  }
}
